import React from 'react';

const steps = [
  {
    number: '01',
    title: 'Sign Up & Get API Key',
    description: 'Create your developer account and generate an API key in under a minute.',
    icon: 'fa-key',
  },
  {
    number: '02',
    title: 'Create an Assistant',
    description: 'Configure your agent with business details, services, staff contacts, and personality via API or Studio.',
    icon: 'fa-paint-brush',
  },
  {
    number: '03',
    title: 'Provision & Validate',
    description: 'Infrastructure spins up automatically and runs validation tests before going live. Phone, voice, SMS, email — all provisioned.',
    icon: 'fa-server',
  },
  {
    number: '04',
    title: 'Simulate, Test, Go Live',
    description: 'Run scenario simulations, detect knowledge gaps, and deploy with confidence once validation passes.',
    icon: 'fa-rocket',
  },
];

const HowItWorks = () => {
  return (
    <div className="px-8 py-20 bg-[#f9f9fb]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold font-['Montserrat'] text-[#222324] mb-4">
            From Zero to a Working AI Employee in Minutes
          </h2>
          <p className="text-gray-600 text-lg font-medium font-['Inter'] max-w-2xl mx-auto">
            No telephony expertise. No complex integrations. Deploy an autonomous AI agent that answers calls, coordinates staff, and handles operations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[60%] w-[80%] h-px bg-gray-300"></div>
              )}
              <div className="flex flex-col items-center text-center gap-4">
                <div className="w-16 h-16 bg-[#055EFD] rounded-full flex items-center justify-center relative z-10">
                  <i className={`fa ${step.icon} text-white text-xl`}></i>
                </div>
                <span className="text-[#055EFD] text-xs font-bold font-['Inter'] tracking-widest">STEP {step.number}</span>
                <h3 className="text-lg font-bold font-['Montserrat'] text-[#222324]">{step.title}</h3>
                <p className="text-gray-600 text-sm font-medium font-['Inter']">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
